import {ToastContainer, toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import AppConstants from '../../Constants/AppConstants';
import {messages} from '../../Localization/catalogs';

const localizeMessage = message => {
  if (typeof message !== 'string') return message;
  const locale = String(AppConstants.appLanguage || 'en').toLowerCase().split(/[-_]/)[0];
  return messages[locale]?.[message] || message;
};

const ToastPopup = ({type, message}) => {
  const localizedMessage = localizeMessage(message);
  if (type === 'success') {
    toast.success(localizedMessage, {
      position: 'bottom-right',
      autoClose: 3000,
      hideProgressBar: true,
    });
  }
  if (type === 'error') {
    toast.error(localizedMessage, {
      position: 'bottom-right',
      autoClose: 3000,
      hideProgressBar: true,
    });
  }
  if (type === 'info') {
    toast.info(localizedMessage, {
      position: 'bottom-right',
      autoClose: 3000,
      hideProgressBar: true,
    });
  }
  if (type === 'warning') {
    toast.warn(localizedMessage, {
      position: 'bottom-right',
      autoClose: 3000,
      hideProgressBar: true,
    });
  }
};

// Keep the imperative API used by checkout actions compatible with the
// existing toast component. React components are functions, so these helpers
// can be safely attached without changing the current ToastPopup usage.
ToastPopup.showError = ({message}) =>
  ToastPopup({type: 'error', message});
ToastPopup.showSuccess = ({message}) =>
  ToastPopup({type: 'success', message});

export default ToastPopup;
